<script setup lang="ts">
import { computed, ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

import Header from './Header/Header.vue';
import SideMenu from './SideMenu/SideMenu.vue';
import CreateEditWorkspacePopup from '../../popups/CreateWorkspacePopup/CreateWorkspacePopup.vue';
import CreateEditProjectPopup from '../../popups/CreateProjectPopup/CreateProjectPopup.vue';
import DeleteProjectPopup from '../../popups/DeleteProjectPopup.vue';
import DeleteWorkspacePopup from '../../popups/DeleteWorkspacePopup.vue';
import UploadLimitAlert from '@/dashboard/vue/popups/UploadLimitAlert.vue';
import { useMainLayout } from '@/dashboard/vue/components/layout/useMainLayout';
import ConfirmAlertPopup from '@/dashboard/vue/popups/ConfirmAlertPopup.vue';

const route = useRoute();

const { showSideMenu } = useMainLayout();
const shortLink: ComputedRef<string | undefined> = computed(() => route.params?.short_link as string);
</script>

<template>
  <div class="flex flex-1">
    <Header />
    <div class="main-content flex flex-1" :class="{ 'mx-xs': !showSideMenu }">
      <SideMenu v-if="showSideMenu"></SideMenu>
      <router-view></router-view>
    </div>

    <CreateEditWorkspacePopup />
    <CreateEditProjectPopup />
    <DeleteWorkspacePopup v-if="shortLink" :short-link="shortLink" />
    <DeleteProjectPopup />
    <UploadLimitAlert />
    <ConfirmAlertPopup />
  </div>
</template>
